import React from "react";
import "./parts.css"; // Fichier CSS pour le style
import { Box } from "@mui/material";

const CheckPin = ({ event, onChange }) => {
  return (
    <Box className="check-pin small-padding">
      <label className="check-label">
        <input
          type="checkbox"
          className="checkbox-input"
          checked={event.isPin || false}
          onChange={(e) => onChange("isPin", e.target.checked)}
        />
        <span className="pin-icon">📌</span>
        Épingler
      </label>
    </Box>
  );
};

export default CheckPin;